<template>
  <el-dialog title="Измение медиа-сервера" :visible="visible" v-on="$listeners">
    <el-form id="formServer" label-position="right" label-width="150px" class="form-wrapper">
      <el-card v-if="isThereRegular" header="Обычные камеры">
        <el-form-item label="Медиа-сервер">
          <dvr-servers-select v-model="dvrServerId" />
        </el-form-item>
        <el-form-item label="Принудительно">
          <el-switch
            v-model="regularForce"
            :active-value="1"
            :inactive-value="0"
          />
        </el-form-item>
      </el-card>
      <el-card v-if="isThereRrtsp" header="Камеры с новым агентом">
        <el-form-item label="Медиа-сервер">
          <dvr-servers-select v-model="rrtspDvrServerId" isForRrtsp="1" />
        </el-form-item>
        <el-form-item label="Принудительно">
          <el-switch
            v-model="rrtspForce"
            :active-value="1"
            :inactive-value="0"
          />
        </el-form-item>
      </el-card>
    </el-form>
    <span slot="footer">
      <el-button @click="onClose">Отменить</el-button>
      <el-button id="submitServer" :disabled="isSaveButtonDisabled" :loading="requestLoading" type="primary" @click="onSave">Сохранить</el-button>
    </span>
  </el-dialog>
</template>

<script>
import DvrServersSelect from "@/components/Server/feature/DvrServersSelect";
import camerasDialogsMixin from "@/components/Cameras/components/dialogs/camerasDialogsMixin";
import { ApiService } from "@/api";
import { mapState } from "vuex";

export default {
  name: "CamerasDvrServerDialog",
  components: { DvrServersSelect },
  mixins: [camerasDialogsMixin],
  data() {
    return {
      dvrServerId: null,
      rrtspDvrServerId: null,
      regularForce: 0,
      rrtspForce: 0,
      regularCameras: [],
      rrtspCameras: [],
      isThereRegular: false,
      isThereRrtsp: false,
    };
  },
  computed: {
    isSaveButtonDisabled() {
      return (this.isThereRegular && this.dvrServerId === null) || (this.isThereRrtsp && this.rrtspDvrServerId === null)
    },
    ...mapState("cameras", {
      camerasList: (state) => state.cameras.data,
    }),
  },
  created() {
    const findCameraById = (id) => {
      return this.camerasList.find(c => c.id_camera === id);
    }
    this.regularCameras = this.cameras.filter((id) => {
      const camera = findCameraById(id);
      return camera && camera.is_rrtsp === 0;
    });
    this.rrtspCameras = this.cameras.filter((id) => {
      const camera = findCameraById(id);
      return camera && camera.is_rrtsp === 1;
    });
    this.isThereRegular = this.regularCameras.length > 0;
    this.isThereRrtsp = this.rrtspCameras.length > 0;
  },
  methods: {
    onSave() {
      const requests = [];
      if (this.isThereRegular) {
        requests.push({
          type: "regular",
          promise: ApiService.cameras.updateCamerasDvrServer(this.dvrServerId, this.regularCameras, this.regularForce),
        });
      }
      if (this.isThereRrtsp) {
        requests.push({
          type: "rrtsp",
          promise: ApiService.cameras.updateCamerasDvrServer(this.rrtspDvrServerId, this.rrtspCameras, this.rrtspForce),
        });
      }

      this.requestLoading = true;
      Promise.allSettled(requests.map((request) => request.promise))
        .then((results) => {
          const successfulResponses = [];
          let hasError = false;
          let errorMessage = "Произошла ошибка при обновлении камер";

          results.forEach((result, index) => {
            const requestType = requests[index].type;

            if (result.status === "fulfilled") {
              successfulResponses.push(result.value);
              if (requestType === "regular") {
                this.isThereRegular = 0;
              }
              if (requestType === "rrtsp") {
                this.isThereRrtsp = 0;
              }
              return;
            }

            hasError = true;
            errorMessage = result.reason?.response?.data?.error || errorMessage;
            this.$message.error(errorMessage);
          });

          if (hasError && successfulResponses.length > 0) {
            this.$emit("updated", true);
          }

          if (!hasError) {
            this.$emit("updated");
            this.$message.success("Камеры успешно обновлены");
            this.onClose();
          }
        })
        .finally(() => {
          this.requestLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.form-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
